import router from '@/routers';

export default function cashier({ next }) {
    const user = JSON.parse(localStorage.getItem('user'));
    console.log(user);
    if (user.role !== 'CASHIER') {
        return router.replace('/home');
    } else {
        return next();
    }
}